const checkboxState = Object.freeze({
  UNCHECKED: "unchecked",
  CHECKED: "checked",
  INDETERMINATE: "indeterminate",
});

export default checkboxState;
